<template>
  <v-navigation-drawer
    app
    permanent
    width="var(--drawer-width)"
    color="var(--drawer-color)"
    :mini-variant.sync="minimizeMenu"
    mini-variant-width="85"
  >
    <div class="flex-center py-5">
      <v-img
        eager
        :src="require('../assets/Logo2.png')"
        width="80"
        max-width="80"
      ></v-img>
    </div>

    <v-layout
      justify-space-between
      align-center
      class="pa-3"
      style="min-height: var(--header-height); max-height: var(--header-height)"
    >
      <v-flex class="name-box">
        <div class="txt-mini font-type-bold txt-short theme-color-one d-flex justify-space-between align-center">
          <div>
            {{ userRole }}
          </div>
          <div>
            <v-btn v-if="userRole==='USP'" small icon @click="$router.push('/edit-profile')" >
              <Iconify
                  style="color: #F7941D"
                  icon="material-symbols:edit"
                  size="15px"
              ></Iconify>
            </v-btn>
          </div>
        </div>
        
        <div class="txt-normal txt-short">{{ userName }}</div>
      </v-flex>
    
      <!--      <v-flex v-if="!minimizeMenu" shrink ml-2>-->
      <!--        <v-btn icon @click="minimizeMenu = !minimizeMenu">-->
      <!--          <v-icon>chevron_left</v-icon>-->
      <!--        </v-btn>-->
      <!--      </v-flex>-->
    </v-layout>

    <v-list dense nav class="py-3 px-0">
      <!--   PARENT MENU (without submenu)   -->
      <div v-for="item in filteredPermissionAccess(menus)" :key="item.name">
        <v-list-item
          v-if="!item.submenu"
          link
          :disabled="item.disabled"
          :class="{ 'current-item-list-active': isSameMenu(item.route) }"
          @click="item.disabled ? () => {} : onNavigate(item)"
        >
          <v-sheet
            class="d-flex align-center pl-6 pr-3"
            width="calc(var(--drawer-width) - 3px)"
            height="var(--menu-item-height)"
          >
            <Iconify
              :icon="item.icon"
              :disabled="item.disabled"
              class="mr-3"
            ></Iconify>

            <v-list-item-content>
              <v-list-item-title
                style="line-height: 1.2rem; font-size: unset"
                :class="{ 'disabled-menu': item.disabled }"
              >
                {{ item.name }} 
              </v-list-item-title>
            </v-list-item-content>
          </v-sheet>
        </v-list-item>

        <!--   PARENT MENU (has submenu)   -->
        <v-list-group
          v-else
          :value="isChildActive(item)"
          active-class="current-group-list-active"
          color="var(--theme-color-one)"
        >
          <!--   PARENT TITLE   -->
          <template v-slot:activator>
            <v-sheet
              class="d-flex align-center pl-6 pr-3"
              width="calc(var(--drawer-width) - 3px)"
              height="var(--menu-item-height)"
            >
              <Iconify
                :icon="item.icon"
                :disabled="item.disabled"
                class="mr-3"
              ></Iconify>

              <v-list-item-content>
                <v-list-item-title
                  style="line-height: 1.2rem; width: 1px;"
                  class="text-truncate w-[1px]"
                  :class="{ 'disabled-menu': item.disabled }"
                >
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-sheet>
          </template>

          <!--   CHILDREN MENU   -->
          <v-list-item
            v-for="sub in filteredPermissionAccess(item.submenu)"
            :key="sub.name"
            link
            :disabled="sub.disabled"
            :class="{ 'current-item-list-active': isSameMenu(sub.route) }"
            @click="sub.disabled ? () => {} : onNavigate(sub)"
          >
            <v-sheet
              color="#FAFAFA"
              class="d-flex align-center pl-6 pr-3"
              width="calc(var(--drawer-width) - 3px)"
              height="var(--menu-item-height)"
            >
              <Iconify
                :icon="sub.icon"
                :disabled="sub.disabled"
                class="mr-3"
              ></Iconify>

              <v-list-item-content>
                <v-list-item-title
                  style="
                    line-height: 1.2rem;
                    overflow: unset;
                    text-overflow: unset;
                    white-space: unset;
                  "
                  :class="{ 'disabled-menu': sub.disabled }"
                >
                  {{ sub.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-sheet>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { getCookie__c } from "../plugins/cookies";
import { mapState } from "vuex";
import store from "@/store";

export default {
  name: "SideMenu",
  data() {
    return {
      minimizeMenu: false,
      menus: [
        {
          name: "Dashboard",
          requireRole: ["USP", "RSP", "สป.อว."],
          route: "Dashboard",
          icon: "ph:chart-line-up-bold",
        },
        {
          name: "Requirement Form",
          requireRole: ["USP", "RSP", "สป.อว.",'ผู้ประกอบการ'],
          route: "RequirementList",
          icon: "bxs:message-square-detail",
        },
        {
          name: "Website RSP",
          requireRole: ["USP", "RSP", "สป.อว."],
          external: "http://rsp.mhesi.go.th",
          icon: "jam:world",
        },
        {
          name: "เว็บบอร์ด",
          requireRole: ["USP", "RSP", "ผู้ประกอบการ", "ผู้เชี่ยวชาญ"],
          route: "Webboard",
          icon: "mdi:forum-outline",
        },
        {
          name: "เว็บบอร์ด",
          requireRole: ["สป.อว."],
          icon: "mdi:forum-outline",
          submenu: [
            {
              name: "รายการเว็บบอร์ด",
              route: "Webboard",
              requireRole: ["สป.อว."],
              icon: "mdi:forum-outline",
            },
            {
              name: "รายการยกเลิก",
              route: "WebboardDeleteRequests",
              requireRole: ["สป.อว."],
              icon: "fluent:calendar-cancel-20-regular",
            },
          ],
        },
        {
          name: "พิจารณาแผนงาน",
          route: "EvaluateList",
          requireRole: ["ผู้เชี่ยวชาญ"],
          requirePlanIds: [1, 2, 3, 4],
          icon: "fluent:task-list-square-ltr-24-filled",
        },
        {
          name: "จัดการโครงการ",
          requireRole: ["USP", "RSP", "สป.อว."],
          icon: "fluent:task-list-square-ltr-24-filled",
          submenu: [
            {
              name: "โครงการหลัก",
              route: "MainProject",
              requireRole: ["สป.อว."],
              icon: "fluent:task-list-square-ltr-24-filled",
            },
            {
              name: "แผนงานที่เปิดรับ",
              route: "AvailablePlan",
              requireRole: ["USP", "RSP"],
              icon: "fluent:task-list-square-ltr-24-filled",
            },
            {
              name: "ข้อเสนอโครงการ",
              route: "PlanOfferList",
              requireRole: ["USP", "RSP"],
              icon: "icon-park-solid:inbox-download-r",
            },
            {
              name: "แบบฟอร์มพิจารณา",
              route: "ConsiderFormList",
              requireRole: ["สป.อว."],
              icon: "mdi:email-edit",
            },
            {
              name: "โครงการหลักที่ยื่นเสนอ สป.อว",
              route: "MainProjectOffer",
              requireRole: ["RSP"],
              icon: "icon-park-solid:inbox-upload-r",
            },
            {
              name: "โครงการที่รับยื่นจาก RSP และผลพิจารณา",
              route: "ProjectOfferFromRSP",
              requireRole: ["สป.อว."],
              icon: "icon-park-solid:inbox-download-r",
            },
            {
              name: "โครงการที่ได้รับการจัดสรร",
              route: "AllocatedProjectList",
              requireRole: ["USP"],
              icon: "icon-park-solid:inbox-download-r",
            },
            // {
            //   name: 'โครงการหลักที่ยื่นเสนอ สป.อว',
            //   route: '',
            //   icon: 'icon-park-solid:inbox-upload-r'
            // },
            // {
            //   name: "ตั้งค่า",
            //   route: "",
            //   requireRole: ["สป.อว."],
            //   icon: "material-symbols:settings-applications-rounded",
            // },
            {
              name: "ติดตามความก้าวหน้า (รายเดือน)",
              route: "MonthlyProgressList",
              requireRole: ["USP"],
              icon: "ion:mail-unread",
            },
            {
              name: "ติดตามความก้าวหน้า (รายเดือน)",
              route: "RSPMonthlyProgressList",
              requireRole: ["RSP"],
              icon: "ion:mail-unread",
            },
            {
              name: "การติดตาม แบบ S-curve หรือ PBM ในทุกโครงการ",
              route: "ProgressFollowed",
              requireRole: ["RSP", "สป.อว."],
              icon: "ion:mail-unread",
            },
            {
              name: "ยื่นขอขยายเวลา",
              route: "USPExtendTimeList",
              requireRole: ["USP", "RSP"],
              icon: "ion:calendar",
            },
            {
              name: "ยื่นขอขยายเวลาที่ยื่นเสนอ สป.อว",
              route: "RSPExtendTimeList",
              requireRole: ["RSP"],
              icon: "ion:document-text",
            },
            {
              name: "ยื่นขอขยายเวลาที่รับยื่นจาก RSP",
              route: "SPExtendTimeList",
              requireRole: ["สป.อว."],
              icon: "ion:document-text",
            },
            {
              name: "รายงานความก้าวหน้า",
              route: "ProgressReportList",
              requireRole: ["USP", "RSP"],
              icon: "ion:document-text",
            },
            {
              name: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
              route: "ReportFromRSPList",
              requireRole: ["สป.อว."],
              icon: "ion:document-text",
            },
            {
              name: "รายงานความก้าวหน้าที่ยื่น สป.อว",
              route: "ProgressReportOfferList",
              requireRole: ["RSP"],
              icon: "ion:document-text",
            },
          ],
        },
        {
          name: "จัดการผู้ใช้งาน",
          route: "UserManagement",
          requireRole: ["RSP", "สป.อว.", "Admin"],
          icon: "heroicons:users-solid",
          submenu: [
            {
              name: "ผู้ใช้งาน",
              route: "UserManagement",
              requireRole: ["RSP", "สป.อว."],
              icon: "heroicons:users-solid",
            },
            {
              name: "กิจกรรมผู้ใช้งาน",
              route: "LogActivity",
              requireRole: ["RSP", "สป.อว."],
              icon: "ion:document-text",
            },
          ],
        },
        {
          name: "จัดการคำร้องขอใช้พื้นที่",
          requireRole: ["RSP", "สป.อว.", "Admin", "ผู้ประกอบการ"],
          icon: "fluent:task-list-square-ltr-24-filled",
          submenu: [
            {
              name: "แบบฟอร์มคำร้องขอใช้พื้นที่",
              route: "spaceRequestsList",
              requireRole: ["ผู้ประกอบการ", "RSP"],
              icon: "ion:document-text",
            },
            {
              name: "แบบฟอร์มคำร้องทั้งหมด",
              route: "spaceRequestsAll",
              requireRole: ["RSP"],
              icon: "ion:document-text",
            },
            {
              name: "แบบฟอร์มที่ยื่นเสนอ สป.อว.",
              route: "spaceRequestsOffer",
              requireRole: ["RSP"],
              icon: "ion:document-text",
            },
            {
              name: "แบบฟอร์มคำร้องขอใช้บริการพื้นที่ได้จาก RSP",
              route: "spaceRequestsRSP",
              requireRole: ["สป.อว."],
              icon: "ion:document-text",
            },
          ],
        },
        {
          name: "เมนูพิจารณาคำร้องขอใช้พื้นที่",
          requireRole: ["ผู้เชี่ยวชาญ"],
          requirePlanIds: [5],
          route: "EvaluateRequest",
          icon: "fluent:task-list-square-ltr-24-filled",
        },
        {
          name: "ปฏิทินกิจกรรม",
          route: "CalendarActivity",
          requireRole: ["RSP","สป.อว."],
          // requireRole: ["USP","RSP","สป.อว."],
          icon: "fluent:calendar-20-filled",
        },
        {
          name: "ระบบประเมินระดับเทคโนโลยีTCCL",
          route: "TechnologyEvaluation",
          requireRole: ["RSP","สป.อว."],
          // requireRole: ["USP","RSP","สป.อว."],
          icon: "fluent:document-text-24-filled",
        },
        {
          name: "ฐานข้อมูลประวัติผู้ใช้บริการ",
          requireRole: ["RSP"],
          route: "UserServiceHistory",
          icon: "fluent:task-list-square-ltr-24-filled",
        },
        {
          name: "ติดตามความก้าวหน้า โครงการที่รับทุน Fundamental Fund",
          requireRole: ["RSP", "USP", "สป.อว.", "Admin"],
          route: "ProgressFundamentalList",
          icon: "ion:mail-unread",
        },
        {
          name: "ออกจากระบบ",
          route: "Logout",
          icon: "majesticons:logout",
        },
      ],
      fullName: "-",
      email: "-",
    };
  },
  created() {
    try {
      this.fullName = JSON.parse(getCookie__c("session_login")).user.fullName;
      this.email = JSON.parse(getCookie__c("session_login")).user.email;
    } catch (e) {
      this.fullName = "-";
      this.email = "-";
    }

    if(!this.userName) {
      // try to get user info from cookie
      const userInfo = JSON.parse(getCookie__c("session_login")).user;
      if(!userInfo) {
        // back to login page
        store.commit("Auth/clearUserInfo");
        window.location.href = "/";
      }
    }
  },
  computed: {
    ...mapState({
      userRole: (state) => state.Auth.User?.user_type,
      userName: (state) => state.Auth.User?.name,
      planMasterIds: (state) => state.Auth.User?.plan_master_ids ?? [],
    }),
  },
  methods: {
    isSameMenu(routeName) {
      switch (this.$route.name) {
        case "Dashboard":
          return routeName === "Dashboard";

        case "RequirementList":
        case "RequirementForm":
          return routeName === "RequirementList";

        case "Webboard":
        case "WebboardCreate":
        case "WebboardDetail":
          return routeName === "Webboard";

        case "WebboardDeleteRequests":
          return routeName === "WebboardDeleteRequests";

        case "AvailablePlan":
        case "AvailablePlanList":
        case "AvailablePlanListEdit":
        case "FormA":
        case "FormC":
        case "FormD":
          return routeName === "AvailablePlan";

        case "PlanOfferList":
          return routeName === "PlanOfferList";

        case "AllocatedProjectList":
          return routeName === "AllocatedProjectList";

        case "ProgressFollowed":
          return routeName === "ProgressFollowed";

        case "MonthlyProgressList":
          return routeName === "MonthlyProgressList";

        case "ConsiderFormList":
          return routeName === "ConsiderFormList";

        case "UserManagement":
          return routeName === "UserManagement";

        case "UserFormManagement":
          return routeName === "UserFormManagement";

        case "LogActivity":
          return routeName === "LogActivity";

        case "MainProject":
        case "MainProjectForm":
          return routeName === "MainProject";

        case "MainProjectOffer":
        case "FormB":
          return routeName === "MainProjectOffer";

        case "ProjectOfferFromRSP":
          return routeName === "ProjectOfferFromRSP";

        case "ProgressReportList":
          return routeName === "ProgressReportList";

        case "ProgressReportOfferList":
          return routeName === "ProgressReportOfferList";

        case "ReportFromRSPList":
          return routeName === "ReportFromRSPList";

        case "spaceRequestsList" :
        case "spaceRequestsForm":
          return routeName === "spaceRequestsList"
        case "spaceRequestsAll":
          return routeName === "spaceRequestsAll"
        case "EvaluateRequest":
            return routeName === "EvaluateRequest"
        case "EvaluateList":
          return routeName === "EvaluateList"     
        case "spaceRequestsOffer":
          return routeName === "spaceRequestsOffer" 
        case "spaceRequestsRSP":
          return routeName === "spaceRequestsRSP" 
        case "UserServiceHistory":
        case "UserServiceHistoryCreate":
        case "UserServiceHistoryId":
        case "UserServiceHistoryEdit":
          return routeName === "UserServiceHistory" 
        case "RSPMonthlyProgressList":
          return routeName === "RSPMonthlyProgressList" 
        case "USPExtendTimeList":
          return routeName === "USPExtendTimeList"   
        case "RSPExtendTimeList":
          return routeName === "RSPExtendTimeList"   
        case "CalendarActivity":
          return routeName === "CalendarActivity"   
        case "TechnologyEvaluation":  
          return routeName === "TechnologyEvaluation"
        case "SPExtendTimeList":
          return routeName === "SPExtendTimeList"
          
        case "ProgressFundamentalList":
        case "ProgressFundamentalForm":
          return routeName === "ProgressFundamentalList"
        default:
          return false;
      }
    },
    isChildActive(parent) {
      return parent.submenu.find((x) => x.route === this.$route.name);
    },
    async onNavigate(item) {
      if (item.route === "Logout") {
        await this.$apiFire("Auth/logout");
        this.$store.commit("Auth/clearUserInfo");
        return this.$router.push({ name: "Home" });
      }
      if (item.external) return window.open(item.external);
      return this.$router.push({ name: item.route });
    },
    filteredPermissionAccess(menus) {
      return menus.filter((x) => {
        const hasRoleAccess = !x.requireRole || x.requireRole.includes(this.userRole);
        if (!hasRoleAccess) return false;
        if (x.requirePlanIds) {
          return x.requirePlanIds.some((id) => this.planMasterIds.includes(id));
        }
        return true;
      });
    },
    
  },
};
</script>

<style scoped lang="scss">
.name-box {
  background: #fafafa;
  border: 1px solid var(--theme-color-nine);
  border-radius: 10px;
  padding: 8px 16px;
}
.disabled-menu {
  color: var(--theme-color-nine);
}
</style>
